import { Controller } from "@hotwired/stimulus"

// Interactive readout for the API-spending stacked bar chart. The bars are
// pure CSS (server-rendered, grouped by provider or model); this controller
// only swaps the header readout (day total + per-group breakdown + date) as
// the cursor moves across bars, reverting to the latest day ("· latest") on
// mouse-leave. Range + group-by are server round-trips.
export default class extends Controller {
  static targets = ["bar", "total", "date", "parts"]

  hover(event) {
    const bar = event.currentTarget
    this.render(bar.dataset.total, bar.dataset.date, bar.dataset.parts)
  }

  reset() {
    const bars = this.barTargets
    if (bars.length === 0) return
    const last = bars[bars.length - 1]
    this.render(last.dataset.total, `${last.dataset.date} · latest`, last.dataset.parts)
  }

  render(total, date, partsJson) {
    if (this.hasTotalTarget) this.totalTarget.textContent = total
    if (this.hasDateTarget) this.dateTarget.textContent = date
    if (this.hasPartsTarget) {
      let parts = []
      try { parts = JSON.parse(partsJson || "[]") } catch (_e) { parts = [] }
      this.partsTarget.innerHTML = parts.map((p) => {
        const swatch = `<span class="inline-block w-2 h-2 rounded-sm mr-1 align-middle" style="background:${p.c}"></span>`
        return `<span class="inline-flex items-center mr-3 text-xs text-gray-500 dark:text-gray-400">${swatch}${this.escape(p.l)}&nbsp;${this.escape(p.v)}</span>`
      }).join("")
    }
  }

  escape(str) {
    const div = document.createElement("div")
    div.textContent = str == null ? "" : String(str)
    return div.innerHTML
  }
}
